import { RaceResultsTable } from './RaceResultsTable';

export default RaceResultsTable;
